module.exports = __webpack_public_path__ + "img/markerMetroGreen.a5e2c45e.svg";